import React from 'react';
import Weather from './Weather';
import './App.css';

function App() {
  return (
    <Weather/>
  );
}

export default App;
